import { FC } from 'react';
import ModalBackdrop from '../../components/RegistrationProgressComponents/Modals/ModalBackdrop';
import '../../components/RegistrationProgressComponents/Modals/styles.scss';
import Modal from '@components/Modal/Modal';

const DeleteModal: FC<{
  open: boolean;
  onDelete: () => void;
  onClose: () => void;
}> = ({ open, onDelete, onClose }) => {
  return (
    <Modal
      open={open}
      title="Delete Card"
      bodyParagraphs={[
        "This will permanently delete your card on file. Do you wish to continue?",
      ]}
      buttons={[
        {
          variant: "contained",
          label: "Delete",
          onClick: onDelete,
        },
        {
          variant: "text",
          label: "Cancel",
          onClick: onClose,
        },
      ]}
      onClose={onClose}
    />
  );
};

export default DeleteModal;
